import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { PostAccountRole } from '@/services/ws-post-crm/src/main/resources/rest-api';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Filter } from '@/js/libs/ui/src/V2';

import { useTranslateOptionLabel } from 'src/hooks/useTranslateOptionLabel';
import type { Option } from 'src/types';

interface PostAccountRoleFilterProps {
  value: Option<PostAccountRole>[];
  onChange: (value: Option<PostAccountRole>[]) => void;
  label?: string;
}

export const PostAccountRoleFilter = memo(function PostAccountRoleFilter({ value, onChange, label }: PostAccountRoleFilterProps) {
  const [t] = useTranslation(['backend', 'common', 'reporting']);
  const translateOptionLabel = useTranslateOptionLabel(t);

  const options = useMemo(
    () =>
      Object.values(PostAccountRole).map((role) => ({
        label: role,
        value: role,
      })),
    [],
  );

  const handleChange = useCallbackRef((newValue: Option<PostAccountRole>[]) => {
    onChange(newValue);
  });

  return (
    <Filter<PostAccountRole>
      label={label ?? t('common:ROLES')}
      selected={value}
      onChange={handleChange}
      options={options}
      dataTestId='role-dropdown'
      formatOptionLabel={translateOptionLabel}
      isMulti
    />
  );
});
